import React from 'react';
import { brand, footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-line bg-ivory py-12 md:py-16" data-id="element-64" data-mp="3gfsnkey6wyo1">
      <div className="mx-auto w-full max-w-4xl px-5 text-center md:px-8" data-id="element-65" data-mp="32nukolv2nz0b">
        <p className="font-serif text-2xl font-semibold text-wine md:text-3xl" data-id="element-66" data-mp="32pp5m06cfr4e">{brand.name}</p>
        <p className="mt-2 text-muted" data-id="element-67" data-mp="36ppl7o56i8d1">{brand.tagline}</p>

        <nav aria-label="Enlaces del sitio" data-id="element-68" data-mp="3uesa9h2573hk">
          <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm font-semibold text-muted" data-id="element-69" data-mp="3ucxoy1myl9cy">
            {footerLinks.map(link => <li key={link.label} data-id="element-70" data-mp="3ldaphldsidmj">
                <a href={link.href} className="rounded transition-colors duration-150 ease-[cubic-bezier(0.23,1,0.32,1)] hover:text-wine focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold/60" data-id="element-71" data-mp="3lggbgrr4gze1">
                  {link.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <p className="mt-8 text-sm text-muted" data-id="element-72" data-mp="3la288r748xtn">
          © 2026 {brand.name}. Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}